import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199648d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "corporate-header" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = {
  key: 0,
  class: "header-nav"
}
const _hoisted_4 = { class: "header-nav-item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "header-nav-item"
}
const _hoisted_7 = { class: "header-nav-item" }
const _hoisted_8 = { class: "header-nav-item" }
const _hoisted_9 = { class: "header-nav-item" }
const _hoisted_10 = {
  key: 1,
  class: "header-nav-item"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 2,
  class: "header-nav-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_name = _resolveComponent("company-name")!
  const _component_user_sns_buttons = _resolveComponent("user-sns-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_company_name, { "user-account": _ctx.userAccount }, null, 8, ["user-account"]),
      _createVNode(_component_user_sns_buttons, {
        class: "sp",
        "user-account": _ctx.userAccount,
        "medium-id": _ctx.mediumId
      }, null, 8, ["user-account", "medium-id"])
    ]),
    (_ctx.isCorporateTopPage)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                class: _normalizeClass(["header-nav-link", _ctx.linkClass('')]),
                href: `/corporation/${_ctx.userAccount.userAccountId}`
              }, "ホーム", 10, _hoisted_5)
            ]),
            (_ctx.userAccount.hasArticles)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["header-nav-link", _ctx.linkClass('user-new-articles')]),
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.move('#user-new-articles')), ["prevent"]))
                  }, "プレスリリース", 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", {
                class: _normalizeClass(["header-nav-link", _ctx.linkClass('user-recruits')]),
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.move('#user-recruits')), ["prevent"]))
              }, "採用情報", 2)
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["header-nav-link", _ctx.linkClass('user-columns')]),
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.move('#user-columns')), ["prevent"]))
              }, "コラム", 2)
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("a", {
                class: _normalizeClass(["header-nav-link", _ctx.linkClass('user-info')]),
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.move('#user-info')), ["prevent"]))
              }, "企業情報", 2)
            ]),
            (_ctx.userAccount.hasPressKit)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "header-nav-link",
                    href: _ctx.pressKitUrl
                  }, "プレスキット", 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            (_ctx.userAccount.hasGalleryImages)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["header-nav-link", _ctx.linkClass('user-image-gallery')]),
                    href: "#",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.move('#user-image-gallery')), ["prevent"]))
                  }, "画像ギャラリー", 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}